<template>
  <div class="dockCase">
    <p class="line"></p>
    <div class="w1200Auto">
      <div class="hotTitle">
        <p class="hotTitle_l">对接案例</p>
        <!--        <p class="hotTitle_r" @click="getMore">查看更多 ></p>-->
      </div>
      <div class="dockCase_tabs">
        <div
          @click="getTabs(index, item.list)"
          v-for="(item, index) in caseList"
          :key="index"
          class="dockCase_tabsText"
          :class="index == active ? 'dockCase_active' : ''"
        >
          <img :src="item.imgs" alt="" />
          <p>{{ item.name }}</p>
        </div>
      </div>
      <div>
        <el-carousel height="416px">
          <el-carousel-item v-for="(item, index) in caseMesgList" :key="index">
            <div class="dockCase_content">
              <div class="dockCase_right">
                <h2 @click="getCaseDetails(item.id)">{{item.title}}</h2>
                <p class="dockCase_right_content">
                  {{item.info}}
                </p>
              </div>
              <div class="img_box" >
                <img :src="item.fileEntity[0].url" alt="" v-if="item.fileEntity.length"/>
              </div>
            </div>
          </el-carousel-item>
        </el-carousel>
      </div>
    </div>
  </div>
</template>

<script>
import { caseListByType } from "../../utils/interface";

export default {
  data() {
    return {
      active: 0,
      baseImgs: [
        {
          imgs: require("../../assets/supplyHome/mjzz.png"),
          code:'ZA',
          name: "模具制造",
        },
        {
          imgs: require("../../assets/supplyHome/lbjjg.png"),
          code:'ZB',
          name: "零部件加工",
        },
        {
          imgs: require("../../assets/supplyHome/sbzz.png"),
          code:'ZC',
          name: "水泵组装",
        },
        {
          imgs: require("../../assets/supplyHome/sbzz.png"),
          code:'ZD',
          name: "物流供需",
        },
        {
          imgs: require("../../assets/supplyHome/jcfu.png"),
          code:'ZE',
          name: "检测服务",
        },
        {
          imgs: require("../../assets/supplyHome/hbfw.png"),
          code:'ZF',
          name: "环保服务",
        },
        {
          imgs: require("../../assets/supplyHome/znhfw.png"),
          code:'ZG',
          name: "智能化服务",
        },
        {
          imgs: require("../../assets/supplyHome/jrfu.png"),
          code:'ZH',
          name: "金融服务",
        },
        {
          imgs: require("../../assets/supplyHome/qtfw.png"),
          code:'ZI',
          name: "其他服务",
        },
      ],
      caseList: [],
      caseMesgList: [],
    };
  },
  created() {
    this.caseInfoList();
  },
  methods: {
    caseInfoList() {
      this.caseList = [];
      caseListByType().then((res) => {
        // console.log("11-----------------", res);
        if (res.data) {
          for (let key in res.data) {
            console.log(key + "-----------" + res.data[key]);
            this.baseImgs.forEach((item, index) => {
              if (item.code == key) {
                this.caseList.push({
                  name: item.name,
                  imgs: item.imgs,
                  list: res.data[key]
                });
              }
            });
          }
          this.caseMesgList = this.caseList[0].list;
          // console.log(2222222, this.caseMesgList)
        }
      });
    },
    getCaseDetails(id) {
      let routeData = this.$router.resolve({
        name: "caseDetails",
        params: { uuid: id },
        query:{type:'buttJoint'}
      });
      window.open(routeData.href, "_blank");
    },
    getTabs(index, list) {
      this.active = index;
      this.caseMesgList = list;
    },
    getMore() {
      let routeData = this.$router.resolve({
        path: "/dynamicsList",
      });
      window.open(routeData.href, "_blank");
    },
  },
};
</script>

<style lang="less" scoped>
@import "./style/index.less";
.dockCase {
  background: #f4f5f6;
  padding-top: 40px;
  position: relative;
}

.dockCase_tabs {
  display: grid;
  grid-template-columns: 90px 90px 90px 90px 90px 90px 90px 90px;
  grid-column-gap: 46px;
  justify-content: center;
  text-align: center;
  margin-top: 20px;
  font-weight: 500;
  color: #000;
  min-height: 115px;
  cursor: pointer;
  .dockCase_tabsText {
    margin-top: 12px;
    img {
      margin-bottom: 16px;
      // width: 48px;
      height: 38px;
    }
    p {
      padding-bottom: 17px;
    }
    &:hover {
      color: #2d50a1;
    }
  }
  .dockCase_active {
    color: #2d50a1;
    border-bottom: 2px solid #2d50a1;
    z-index: 99;
  }
  p {
    font-size: 18px;
  }
  span {
    font-size: 20px;
  }
}
.line {
  position: absolute;
  top: 199px;
  width: 100%;
  height: 1px;
  background: #e2e3e5;
}
.dockCase_content {
  box-sizing: border-box;
  margin-top: 20px;
  position: relative;
  .img_box {
    position: absolute;
    top: -44px;
    right: 0;
    width: 595px;
    height: 327px;
    background: #29b8aa;
    border-radius: 16px;
    box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);

    img {
      width: 100%;
      height: 100%;
      border-radius: 16px;
    }
  }
  .dockCase_right {
    width: 638px;
    box-sizing: border-box;
    margin-top: 85px;
    box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);
    background: #fff;
    border-radius: 8px;
    padding: 45px 118px 45px 49px;
    height: 330px;
    h2 {
      cursor: pointer;
      font-size: 24px;
      margin-bottom: 16px;
      overflow:hidden;
      text-overflow: ellipsis;
      -webkit-line-clamp: 1;
      display: -webkit-box;
      -webkit-box-orient: vertical;
    }
    .dockCase_right_content {
      font-size: 14px;
      font-weight: 400;
      color: #333333a4;
      line-height: 27px;
      overflow:hidden;
      text-overflow: ellipsis;
      -webkit-line-clamp: 5;
      display: -webkit-box;
      -webkit-box-orient: vertical;
    }
  }
}
/deep/.el-carousel__button {
  background-color: #2d50a1;
}
</style>



// WEBPACK FOOTER //
// src/components/supplyHome/dockCase.vue